<template>
  <div id="index">
    <!-- 头部 -->
    <!-- <Hezuo></Hezuo> -->

    <HeaderTop :headIndex="4" ref="header"></HeaderTop>
    <!-- banner -->
    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
      </div>
    </div>
    <div class="banner banner_swiper swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper_item swiper-slide" v-for="(liem, index) in banner_arr" :key="index" @click.stop="bannerFun(liem)" :style="{
                  background: 'url('  + IMG_URL + liem.url + ') no-repeat',
                  backgroundSize:'100% 100%'
                }">
          <a class="a_have" @click.stop="bannerFun(liem)"></a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="banner-button_prev flex_center">
        <img src="@/assets/img/left_img.png" alt="" />
      </div>
      <div class="banner-button_next flex_center">
        <img src="@/assets/img/right_img.png" alt="" />
      </div>
    </div>
    <!-- 模块选择 -->
    <div class="selectBox flex_between">
      <div class="main select_div">
        <div class="select_li LiveTitle" @click="selectBox_index = 1" :class="{ bule: selectBox_index == 1 }">
          Live
        </div>
        <div class="select_li backTitle" @click="selectBox_index = 2" :class="{ bule: selectBox_index == 2 }">
          精彩回放
        </div>
      </div>
    </div>
    <div class="flex_between arrangement main">
      <div class="flex_center arrangement_li" @click.stop="arrangement_index = 2">
        <i v-if="arrangement_index == 2"><img src="@/assets/img/partyT.png" alt="" /></i>
        <i v-else><img src="@/assets/img/party.png" alt="" /></i>
      </div>
      <div class="flex_center arrangement_li" @click.stop="arrangement_index = 1">
        <i v-if="arrangement_index == 1"><img src="@/assets/img/crossT.png" alt="" /></i>
        <i v-else><img src="@/assets/img/cross.png" alt="" /></i>
      </div>
    </div>
    <!-- 模块内容 -->
    <div class="video_content">
      <!-- Live -->
      <div class="main" v-if="live_arr.length > 0">
        <div class="lm_content" v-if="idloading1">
          <div class="zanwu">
            <img src="@/assets/img/loadding_pc.gif" alt="">
            <div>努力加载中...</div>
          </div>
        </div>
        <div class="video_ul" v-if="arrangement_index == 2">
          <div class="video_li" v-for="liem,index in live_arr" @click="details(liem)" :key="index">
            <div class="video_head flex_between">
              <div class="video_li_title flex_start">
                <!-- <div class="title">{{ liem.name }}</div> -->
                <div class="title"><span v-html="formatet(liem.name)"></span></div>
                <div class="tag flex_center" v-if="selectBox_index == 2">
                  回放
                </div>
              </div>
              <div class="video_cover">
                <img :src="isshowimg(liem.cover)" alt="" />
              </div>
            </div>
            <div class="video_center">
              <!-- <div class="video_name">
                {{ liem.doctor }}
              </div> -->
              <div class="video_name">
                <span v-html="formatet(liem.doctor)"></span>
              </div>
              <div class="tag_title flex_start">
                <span>{{ liem.position }}</span>
                <span>{{ liem.hospital }}</span>
              </div>
            </div>
            <div class="video_bottom flex_between">
              <div class="video_time flex_start">
                <img class="video_time_img" src="@/assets/img/video_icon.png" alt="" />
                <span>直播时间：{{ liem.start_time }} {{ liem.time }}</span>
              </div>
            </div>
          </div>
          <div style="width:1280px">
            <div class="lookmore" v-if="is_request&&selectBox_index===2" @click="getmore">查看更多...</div>
          </div>
        </div>

        <div class="video_ul landscape" v-else>
          <div class="landscape_li flex_between" v-for="liem,index in live_arr" @click="details(liem)" :key="index">
            <div class="video_li_left clamp1">
              <div class="tag flex_center" v-if="selectBox_index == 2">
                回放
              </div>
              <div class="tag flex_center" v-if="selectBox_index == 1">
                直播
              </div>
              {{ liem.name }}
              <!-- {{liem.doctor}} -->
            </div>
            <!-- <i class="video_li_img"><img src="@/assets/img/app_logo.png" alt=""></i> -->
            <div class="time">[ {{ liem.start_time }} ]</div>
          </div>
          <div class="lookmore" v-if="is_request&&selectBox_index===2" @click="getmore">查看更多...</div>
        </div>
      </div>
      <div v-else class="complete">
        <div class="zanwu">
          <img src="@/assets/img/kkry_pc.gif" alt="">
          <div>空空如也...</div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import Footer from "@/components/assembly/Footer.vue"; //尾部模块
import Login from "@/components/assembly/Login.vue"; //登录模块
import "@/assets/js/swiper.animate1.0.3.min.js";
// import "@/assets/js/wx_jsapi.js";
import wx from "weixin-js-sdk";
import Hezuo from "@/components/tool/hezuo.vue";

import "@/assets/js/currency.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/reset.css";
//pc端

export default {
  name: "index",
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      banner_arr: [], //背景图片

      arrangement_index: 2, //排序 1竖排 2方排
      selectBox_index: 0, //切换index
      is_pc: true, //是否是pc端打开
      live_arr: [], //直播数组
      some_arr: [],
      slicenum: 1,
      is_more: true,
      page: 1,
      // seo
      keywords: "",
      idloading: true,
      idloading1: true,
      is_request: true,
    };
  },
  metaInfo() {
    return {
      meta: [{ name: "keywords", content: this.keywords }],
    };
  },
  computed: {},
  components: {
    HeaderTop,
    Footer,
    Hezuo,
  },
  watch: {
    selectBox_index: function (eve, liem) {
      if (eve == 1) {
        this.getLive();
      } else {
        this.playback();
      }
    },
  },
  methods: {
    // seo
    getSeo() {
      this.$get("seo").then((res) => {
        if (res.code == 200) {
          this.keywords = res.data[2];
        }
      });
    },
    bannerFun(liem) {
      //轮播跳转
      if (isNaN(liem.live_id)) {
        window.location.href = liem.live_id;
        return false;
      }
      if (!this.is_judge(liem)) {
        return false;
      }
      if (this._isMobile()) {
        // alert("手机端");
        if (liem.detail.ive_type == 0) {
          //直播
          this.$router.push({
            path: "min_move",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        } else {
          this.$router.push({
            path: "min_record",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        }
      } else {
        // alert("pc端");
        if (liem.detail.ive_type === 0) {
          this.$router.push({
            path: "pc_move",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        } else {
          this.$router.push({
            path: "pc_record",
            query: {
              id: liem.live_id,
              url: liem.detail.live_url,
              power: liem.detail.power,
            },
          });
        }
      }
    },
    searchFun(text) {
      this.searchgetLive(text, 1);
    },
    is_judge(liem) {
      //判断登录

      if (liem.detail.power == 0) {
        return true;
      }
      if (!this.USER()) {
        this.$refs.header.promptShow();
        // layer.open({
        //   content: "请先登录账号",
        //   time: true,
        //   skin: "msg"
        // });
        // setTimeout(()=>{
        //   this.$refs.header.registered(1);
        // },1000)

        return false;
      }
      if (
        (this.USER().plus < 2 && liem.power == 2) ||
        (this.USER().plus == 0 && liem.power == 1)
      ) {
        layer.open({
          content: this.promptPermissions,
          time: true,
          skin: "msg",
        });
        return false;
      }
      return true;
    },
    is_judge2(liem) {
      //判断登录

      if (liem.power == 0) {
        return true;
      }
      if (!this.USER()) {
        this.$refs.header.promptShow();
        // layer.open({
        //   content: "请先登录账号",
        //   time: true,
        //   skin: "msg"
        // });
        // setTimeout(()=>{
        //   this.$refs.header.registered(1);
        // },1000)

        return false;
      }
      if (
        (this.USER().plus < 2 && liem.power == 2) ||
        (this.USER().plus == 0 && liem.power == 1)
      ) {
        layer.open({
          content: this.promptPermissions,
          time: true,
          skin: "msg",
        });
        return false;
      }
      return true;
    },
    details(liem) {
      //跳转页面
      if (!this.is_judge2(liem)) {
        return false;
      }
      let id = liem.id;
      let record_url = liem.record_url;
      let power = liem.power;
      if (this._isMobile()) {
        // alert("手机端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "min_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "min_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      } else {
        // alert("pc端");
        if (this.selectBox_index == 1) {
          //直播
          this.$router.push({
            path: "pc_move",
            query: { id: id, url: record_url, power: power },
          });
        } else {
          this.$router.push({
            path: "pc_record",
            query: { id: id, url: record_url, power: power },
          });
        }
      }
    },
    getLive() {
      this.idloading1 = true;
      //获取直播列表
      let that = this;
      this.$get("live_lists", {}).then((res) => {
        that.live_arr = res.data;

        this.idloading1 = false;
      });
    },
    // 搜索
    searchgetLive(text, num) {
      // if(!num){
      //   this.live_arr=[]
      // }
      let that = this;
      this.$post("index-search", {
        type: 2,
        keyword: text,
        live_type: this.selectBox_index - 1,
      }).then((res) => {
        if (res.data.length < 10) {
          this.is_more = false;
        }
        that.live_arr = res.data;
      });
    },
    formatet(msg) {
      if (sessionStorage.getItem("search") === "") {
        return msg;
      }
      let sou = sessionStorage.getItem("search");
      let str = msg.replace(
        new RegExp(sou, "g"),
        '<span style="color:red">' + sou + "</span>"
      );
      return str;
    },
    playback() {
      this.idloading1 = true;
      //获取录播列表
      let that = this;
      this.slicenum = 1;
      this.$get("record_lists", {}).then((res) => {
        that.some_arr = res.data;
        that.live_arr = that.some_arr.slice(0, this.slicenum * 12);
      });
      this.idloading1 = false;
    },
    getmore() {
      let num = this.slicenum * 12;
      this.slicenum++;

      if (
        this.slicenum * 12 > this.some_arr.length &&
        this.live_arr.length == this.some_arr.length
      ) {
        this.is_request = false;
        return;
      }
      this.live_arr.push(...this.some_arr.slice(num, this.slicenum * 12));
    },
    swiperFun() {
      //实例swiper
      new Swiper(".banner_swiper", {
        pagination: ".swiper-pagination",
        nextButton: ".banner-button_next",
        prevButton: ".banner-button_prev",
        slidesPerView: 1,
        initialSlide: 0,
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 0,
        // loop: true,
      });
    },
    request() {
      //获取banner
      let that = this;
      this.$get("banner_lists", { name: 1 }).then((res) => {
        that.banner_arr = res.data;

        that.$nextTick(function () {
          that.swiperFun();
        });
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 判断完毕后加载样式
    setActiveStyleSheet(filename) {
      document.write("<link href=" + filename + " rel=stylesheet>");
    },
  },
  created() {
    this.idloading = true;
    sessionStorage.removeItem("search");
    this.getSeo();
  },
  mounted() {
    if (this.USER() && this.USER() !== {}) {
      this.REFRESH_USER();
    }
    document.title = "麻醉眼界";
    this.request();
    this.selectBox_index = 1;
    if (this.$route.query.selectBox_index) {
      this.selectBox_index = this.$route.query.selectBox_index;
    }
    this.idloading = false;
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace("/m_index");
    } else {
      // alert("pc端");
      // this.$router.replace('/');
    }
  },
};
</script>
<style>
.banner .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease;
  opacity: 1;
}

.banner .swiper-pagination .swiper-pagination-bullet-active {
  width: 30px;
  height: 12px;
  border-radius: 6px;
  background: #fff;
}
</style>
<style scoped>
#index {
  min-width: 1280px;
}

html {
  /* max-width: 1280px; */
  /* min-width: 865px; */
}

.main {
  max-width: 1280px;
  min-width: 865px;
  margin: 0 auto;
  width: 100%;
}

.hidden-xs {
  /*padding-top:60px;*/
}

.topBox {
  height: 60px;
}

.topBox img {
  width: 171px;
}

.topBox .goWebsite {
  display: inline-block;
  background-color: #db414e;
  height: 34px;
  width: 153px;
  text-align: center;
  line-height: 34px;
  font-size: 13px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
}

.topBox .goWebsite:hover {
  -moz-box-shadow: 0px 0px 2px #40a9ff;
  /* 老的 Firefox */
  box-shadow: 0px 0px 2px #40a9ff;
  font-size: 15px;
}

.banner {
  height: 768px;
  max-width: 1280px;
  position: relative;
}

.banner img {
  width: 100%;
}

.banner .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease;
}

.banner .swiper-pagination .swiper-pagination-bullet-active {
  width: 30px;
  height: 12px;
  border-radius: 6px;
  background: #fff;
}

.banner_swiper {
  position: relative;
}

.banner_swiper .swiper_buttom {
  position: absolute;
  top: 50%;
  width: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.swiper_buttom > div {
  width: 46px;
  height: 60px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  cursor: pointer;
}

.swiper_buttom > div > img {
  width: 15px;
}

.banner-button_next {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  padding: 8px 10px;
}

.banner-button_prev {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  padding: 8px 10px;
}

.selectBox {
  height: 100px;
}

.selectBox .select_div .select_li {
  display: inline-block;
  width: 223px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 6px;
  background-color: #f4f4f4;
  color: #000;
  margin-right: 12px;
}

.selectBox .select_div .select_li.bule {
  color: #fff;
  background-color: #db414e;
}

.selectBox div div:hover {
  -moz-box-shadow: 0px 0px 2px #ccc;
  /* 老的 Firefox */
  box-shadow: 0px 0px 2px #ccc;
}

.arrangement {
  height: 40px;
  background: #f4f4f4;
  border-radius: 6px;
  margin: 10px auto;
}

.arrangement > .arrangement_li {
  width: 50%;
  position: relative;
  cursor: pointer;
}

.arrangement > .arrangement_li:last-child:after {
  width: 3px;
  height: 30px;
  background: #dbdbdb;
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.arrangement > .arrangement_li i {
  width: 26px;
}

.video_content {
  padding: 19px 0;
  background: #f4f6f8;
}
.lookmore {
  width: 334px;
  height: 67px;
  line-height: 67px;
  background: #e5e5e5;
  opacity: 1;
  border-radius: 4px;
  margin-top: 30px;
  font-size: 13px;
  font-family: AdobeHeitiStd-Regular;
  color: #888888;
  opacity: 1;
  text-align: center;
  margin: 30px auto;
  cursor: pointer;
}
.panel {
  background: transparent !important;
  border: 0 !important;
}

.video_content .panel-default > .panel-heading {
  background-color: #ccc;
  background: transparent;
}

.video_ul {
  flex-wrap: wrap;
  width: calc(100% + 40px);
  margin-left: 50%;
  transform: translateX(-50%);
  display: flex;
}

.video_ul .video_li {
  background: #fff;
  /* height: 200px; */
  width: calc(33% - 84px);
  margin: 20px;
  border-radius: 10px;
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.11);
  padding: 0 24px;
  transition: all 0.5s ease;
  cursor: pointer;
  position: relative;
  /* min-width: calc(33% - 40px); */
}

.video_ul .video_li:hover {
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0.32);
}

.video_ul .video_li .video_li_title {
  width: 100%;
  align-items: center;
}

.video_ul .video_li .video_li_title .title {
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-weight: bold;
}

.video_ul .video_li .video_li_title .tag {
  margin-left: 4px;
  width: 33px;
  height: 18px;
  border-radius: 4px;
  background: #ee8a60;
  color: #ffffff;
  font-size: 12px;
}

.video_ul .video_li .video_head {
  padding: 24px 0;
  /* height: 113px; */
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px dashed #e4e4e4;
}
.video_ul .video_li .video_head .video_cover {
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
  height: 180px;
  width: 100%;
  /* max-height: 200px; */
  -webkit-appearance: none;
}
.video_ul .video_li .video_head .video_time > .video_time_img {
  width: 22px;
  height: 22px;
  margin-right: 8px;
}

.video_ul .video_li .video_head .video_time > span {
  font-size: 14px;
  display: inline-block;
  color: #818a92;
  width: calc(100% - 30px);
}

.video_ul.landscape {
  background: #fff;
  padding: 20px 30px;
  border-radius: 6px;
  width: 100%;
}

.video_ul.landscape .landscape_li {
  padding: 20px 10px;
  border-bottom: 1px dashed #eaeaea;
  width: 100%;
  cursor: pointer;
  position: relative;
}

.video_ul.landscape .landscape_li .video_li_left {
  flex: 1;
  text-align: left;
  font-size: 20px;
  color: #1a1a1a;
  line-height: 1em;
  font-weight: bold;
}

.video_ul.landscape .landscape_li .video_li_left > .tag {
  display: inline-flex;
  margin-right: 20px;
  transform: translateY(-2px);
  width: 33px;
  height: 20px;
  border-radius: 4px;
  background: #ee8a60;
  color: #ffffff;
  font-size: 12px;
}

.video_ul.landscape .landscape_li .time {
  font-size: 18px;
  color: #1a1a1a;
}

.video_center {
  align-items: center;
  /* height: calc(100% - 114px); */
  padding: 20px 0 60px 0;
}

.video_center > .touxiao {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.video_center .video_name {
  font-size: 14px;
  color: #525963;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.video_center .tag_title {
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}

.video_center .tag_title > span {
  font-size: 14px;
  color: #525963;
  margin-right: 10px;
  white-space: nowrap;
}
.video_bottom {
  padding: 0 20px 20px 20px;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
}
.video_bottom .video_time > img {
  margin-right: 10px;
}
.selectBox div .bule {
  background-color: #40a9ff;
  color: #fff;
}

.selectBox div .bule:hover {
  -moz-box-shadow: 0px 0px 2px #40a9ff;
  /* 老的 Firefox */
  box-shadow: 0px 0px 2px #40a9ff;
}

.Live {
  display: flex;
  flex-wrap: wrap;
}

.Live li {
  width: 390px;
  cursor: pointer;
  padding: 20px 10px;
  border-radius: 5px;
  margin: 10px;
  display: flex;
  background-color: #fff;
  align-content: center;
  justify-content: center;
}

.Live li:hover {
  -moz-box-shadow: 5px 5px 3px #888888;
  /* 老的 Firefox */
  box-shadow: 5px 5px 3px #888888;
}

.Live li .bigTitle {
  font-size: 16px;
  font-weight: 600;
  display: block;
  margin-bottom: 5px;
  line-height: 18px;
}

.Live li .title {
  width: 260px;
  display: inline-block;
}

.Live li .info {
  color: #aeaeae;
}

.Live li .playTime {
  width: 100px;
  display: inline-block;
  text-align: center;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
}

.Live li .play {
  font-size: 20px;
  display: block;
}

.playBox {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 242, 242, 0.5);
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
}

.Box {
  width: 100%;
  max-width: 700px;
  background-color: #ccc;
  position: relative;
  display: flex;
  align-items: center;
}

.Box .closePlay {
  float: right;
  margin: 10px;
  color: #fff;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
}

.foot {
  text-align: center;
  height: 106px;
  background: #fff;
  font: 12px;
  color: #999999;
}

.foot a {
  color: #999999;
}

html,
body {
  /* max-width: 1280px; */
  /* min-width: 865px; */
  text-align: left;
}

/* banner图 */
.banner {
  height: 600px;
  max-width: 1280px;
}

.banner img {
  width: 100%;
}

.banner_swiper {
  position: relative;
}

.banner_swiper .swiper_item {
  position: relative;
  background-position: center;
  cursor: pointer;
  z-index: 9999;
}
.spinner-box {
  width: 100%;
  height: 90vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.banner_swiper .swiper_item a {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.banner_swiper .swiper_buttom {
  position: absolute;
  top: 50%;
  width: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.swiper_buttom > div {
  width: 46px;
  height: 60px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  cursor: pointer;
}

.swiper_buttom > div > img {
  width: 15px;
}

.selectBox {
  height: 100px;
}

.selectBox .select_div {
  text-align: left;
}

.selectBox .select_div .select_li {
  display: inline-block;
  width: 223px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 6px;
  background-color: #f4f4f4;
  color: #000;
  margin-right: 12px;
}

.selectBox .select_div .select_li.bule {
  color: #fff;
  background-color: #db414e;
}

.selectBox div div:hover {
  -moz-box-shadow: 0px 0px 2px #ccc;
  /* 老的 Firefox */
  box-shadow: 0px 0px 2px #ccc;
}

.video_center .video_name {
  text-align: left;
}
.zanwu {
  text-align: center;
}
.zanwu img {
  width: 20%;
  margin: auto;
  text-align: center;
}
.zanwu div {
  margin-top: 10px;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/index.vue